export default "/_next/static/media/image-9.cb424f58172c825e7e65caf96e2412de.png";